import maEventBus from '@/components/eventbus/index.js'

import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

import maEventbus from '@/components/eventbus'
import maDatePicker from '@/components/datePicker'
import maInputText from '@/components/input/modules/text'
import input from '@/components/input'
import moment from 'moment'

import {
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_SINISTER_SUMMARY,
  WARRANTY_UPDATE_CREATED,
  WARRANTY_UPDATE_PROPS
} from '@/store/types'

import { apiPostDamageUptec } from '@/services/API/damages'

const API_DATE_FORMAT = 'YYYY-MM-DD'
const UPPTEC_DAMAGE_CPI_TYPE = 'CPI'

export default {
  name: 'damageTypeCpi',
  props: {
    poductIdGroup: {
      type: String,
      required: true
    }
  },
  components: {
    maDatePicker,
    maInputText,
    input,
    maEventbus
  },

  data () {
    return {
      inputValDate: null,
      inputValPrice: null
    }
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantySinisterId: 'sinisterId',
      stateWarrantySecondaryId: 'secondaryId',
      stateWarrantyCreated: 'created'
    }),
    ...mapGetters(WARRANTY_MODULE_NAME, {
      getWarrantySinisterHasAddress: 'sinisterHasAddress'
    }),

    isDisabledButton () {
      return [this.stateWarrantySinisterId, this.inputValDate, this.inputValPrice].some(val => val == null || val === '')
    },

    comWarrantyCreated: {
      get () { return this.stateWarrantyCreated },
      set (v) { this.mutWarrantyUpdateCreated(v) }
    },

    externalDamageId: function () {
      return this.FNOLFlow.params.externalDamageId ? this.FNOLFlow.params.externalDamageId : null
    }
  },

  methods: {
    ...mapActions(WARRANTY_MODULE_NAME, {
      'actWarrantyGetSinisterSummary': WARRANTY_GET_SINISTER_SUMMARY,
      'actWarrantyUpdateProps': WARRANTY_UPDATE_PROPS
    }),

    ...mapMutations(WARRANTY_MODULE_NAME, {
      'mutWarrantyUpdateCreated': WARRANTY_UPDATE_CREATED
    }),

    handleChangeInputDate (value) {
      this.inputValDate = value
    },

    handleAddDamagesCpi () {
      const objDamage = {
        'sinister_id': this.stateWarrantySinisterId,
        'event_id': this.stateWarrantySecondaryId,
        'product_group_id': this.poductIdGroup,
        'upptec_damage_type': UPPTEC_DAMAGE_CPI_TYPE,
        'date_of_purchase': this.formatedDate(this.inputValDate),
        'purchase_price': this.inputValPrice,
        'external_damage_id': this.externalDamageId
      }

      apiPostDamageUptec(objDamage)
        .then(() => {
          const isCreated = this.comWarrantyCreated

          maEventbus.$emit('damage:closeAccordion')
          maEventBus.$emit('summary:collapse')

          this.comWarrantyCreated = true

          if (!isCreated && this.getWarrantySinisterHasAddress) {
            this.actWarrantyUpdateProps()
          }

          this.throwNotification(this.$t('notifications.addDamage.title'), this.$t('notifications.addDamage.body'), 'OK')
          this.actWarrantyGetSinisterSummary()
        })
        .catch(errorCode => {
          this.throwNotification(this.$t(`notifications.error.${errorCode}.title`), null, 'KO')
        })
    },

    formatedDate (val) {
      return moment(String(val)).format(API_DATE_FORMAT)
    }
  },

  mounted () {
    maEventBus.$on('iframeUptec:visible', () => {
      this.addDamageBtnIsHidden = true
    })

    maEventBus.$on('iframeUptec:hidden', () => {
      this.addDamageBtnIsHidden = false
    })
  }
}
